export default __webpack_public_path__ + "static/media/manageit-logo.06e2cc1e.svg";